import {
    RadialBarChart,
    RadialBar,
    PolarAngleAxis,
    ResponsiveContainer,
} from 'recharts'
import { KRDS } from '~/components/charts/chart-colors'

interface GaugeProps {
    /** 0~1 비율 */
    ratio: number
    label?: string
    color?: string
    height?: number
}

// 단일 비율 게이지(반원 라디얼). 만족도 긍정 비율 등에 사용. KRDS 색.
export function Gauge({
    ratio,
    label,
    color = KRDS.success,
    height = 180,
}: GaugeProps) {
    const pct = Math.round(ratio * 100)
    const data = [{ name: label ?? '', value: pct, fill: color }]

    return (
        <div className='relative' style={{ height }}>
            <ResponsiveContainer width='100%' height='100%'>
                <RadialBarChart
                    data={data}
                    startAngle={210}
                    endAngle={-30}
                    innerRadius='72%'
                    outerRadius='100%'>
                    <PolarAngleAxis
                        type='number'
                        domain={[0, 100]}
                        tick={false}
                    />
                    <RadialBar
                        dataKey='value'
                        background={{ fill: KRDS.gray[10] }}
                        cornerRadius={8}
                        isAnimationActive={false}
                    />
                </RadialBarChart>
            </ResponsiveContainer>
            <div className='pointer-events-none absolute inset-0 flex flex-col items-center justify-center'>
                <span
                    className='text-3xl font-bold tabular-nums'
                    style={{ color }}>
                    {pct}%
                </span>
                {label ? (
                    <span className='krds-label mt-0.5'>{label}</span>
                ) : null}
            </div>
        </div>
    )
}
